var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { breakpoint } from '../../common/theme/helper';
import { Grid, GridItem, GridItemBorder } from '../../common/components/Grid';
import { ThemedMedia } from '../../common/components/Media';
import { useAccordion } from '../../common/components/Accordion';
import LinkSectionGroup, { LinkSectionDataShape } from './LinkSectionGroup';
/**
 * Overriding styled component with responsive style values
 * results into wrongly ordered media queries.
 * The issue seems to be related to the following one.
 *
 * https://github.com/styled-system/styled-system/issues/561
 */
var FooterGridWrapper = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    padding-top: ", "px;\n  }\n"], ["\n  ", " {\n    padding-top: ", "px;\n  }\n"])), breakpoint(1), themeGet('space.sp_16'));
var FooterGrid = function (props) {
    var __legacy_shop_reboot_max_width = props.__legacy_shop_reboot_max_width, isCollapsible = props.isCollapsible, general = props.general, help = props.help, payment = props.payment, international = props.international, shipping = props.shipping, social = props.social;
    var _a = __read(useAccordion(isCollapsible, ['general']), 2), toggle = _a[0], isExpanded = _a[1];
    return (React.createElement(FooterGridWrapper, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width },
        React.createElement(GridItem, { w: [1, null, 6 / 12] },
            React.createElement(LinkSectionGroup, __assign({}, general, { sectionName: "general", isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle }))),
        React.createElement(GridItem, { w: [1, null, 6 / 12] },
            React.createElement(LinkSectionGroup, __assign({}, help, { sectionName: "help", isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle }))),
        React.createElement(GridItem, { w: [1, null, 3 / 12] },
            React.createElement(LinkSectionGroup, __assign({}, payment, { sectionName: "payment", isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle }))),
        React.createElement(GridItem, { w: [1, null, 3 / 12] },
            React.createElement(LinkSectionGroup, __assign({}, shipping, { sectionName: "shipping", isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle }))),
        React.createElement(GridItem, { w: [1, null, 3 / 12] },
            React.createElement(LinkSectionGroup, __assign({}, international, { sectionName: "international", isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle }))),
        React.createElement(GridItem, { w: [1, null, 3 / 12] },
            React.createElement(LinkSectionGroup, __assign({}, social, { sectionName: "social", isExpanded: isExpanded, isCollapsible: isCollapsible, onTitleClick: toggle }))),
        React.createElement(GridItemBorder, { display: ['none', null, 'block'] })));
};
var FooterLinkSection = function (props) { return (React.createElement(ThemedMedia, null, function (_a) {
    var desktop = _a.desktop;
    return React.createElement(FooterGrid, __assign({ isCollapsible: !desktop }, props));
})); };
FooterLinkSection.propTypes = {
    /** General link section */
    general: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Help link section */
    help: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Shipping link section */
    shipping: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Payment link section */
    payment: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** International link section */
    international: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Social link section */
    social: PropTypes.shape(LinkSectionDataShape).isRequired,
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
FooterLinkSection.defaultProps = {
    __legacy_shop_reboot_max_width: true,
};
export default FooterLinkSection;
var templateObject_1;
